import _toConsumableArray from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _defineProperty from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _classCallCheck from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _possibleConstructorReturn from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/inherits.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { KeyframeResolver } from '../../render/utils/KeyframesResolver.mjs';
import { spring } from '../generators/spring/index.mjs';
import { inertia } from '../generators/inertia.mjs';
import { keyframes } from '../generators/keyframes.mjs';
import { BaseAnimation } from './BaseAnimation.mjs';
import { pipe } from '../../utils/pipe.mjs';
import { mix } from '../../utils/mix/index.mjs';
import { calcGeneratorDuration } from '../generators/utils/calc-duration.mjs';
import { millisecondsToSeconds, secondsToMilliseconds } from '../../utils/time-conversion.mjs';
import { clamp } from '../../utils/clamp.mjs';
import { invariant } from '../../utils/errors.mjs';
import { frameloopDriver } from './drivers/driver-frameloop.mjs';
import { getFinalKeyframe } from './waapi/utils/get-final-keyframe.mjs';
var generators = {
  decay: inertia,
  inertia: inertia,
  tween: keyframes,
  keyframes: keyframes,
  spring: spring
};
var percentToProgress = function percentToProgress(percent) {
  return percent / 100;
};
/**
 * Animation that runs on the main thread. Designed to be WAAPI-spec in the subset of
 * features we expose publically. Mostly the compatibility is to ensure visual identity
 * between both WAAPI and main thread animations.
 */
var MainThreadAnimation = /*#__PURE__*/function (_BaseAnimation) {
  function MainThreadAnimation(options) {
    var _this;
    _classCallCheck(this, MainThreadAnimation);
    _this = _callSuper(this, MainThreadAnimation, [options]);
    /**
     * The time at which the animation was paused.
     */
    _this.holdTime = null;
    /**
     * The time at which the animation was cancelled.
     */
    _this.cancelTime = null;
    /**
     * The current time of the animation.
     */
    _this.currentTime = 0;
    /**
     * Playback speed as a factor. 0 would be stopped, -1 reverse and 2 double speed.
     */
    _this.playbackSpeed = 1;
    /**
     * The state of the animation to apply when the animation is resolved. This
     * allows calls to the public API to control the animation before it is resolved,
     * without us having to resolve it first.
     */
    _this.pendingPlayState = "running";
    /**
     * The time at which the animation was started.
     */
    _this.startTime = null;
    _this.state = "idle";
    /**
     * This method is bound to the instance to fix a pattern where
     * animation.stop is returned as a reference from a useEffect.
     */
    _this.stop = function () {
      _this.resolver.cancel();
      _this.isStopped = true;
      if (_this.state === "idle") return;
      _this.teardown();
      var onStop = _this.options.onStop;
      onStop && onStop();
    };
    var _this$options = _this.options,
      name = _this$options.name,
      motionValue = _this$options.motionValue,
      element = _this$options.element,
      keyframes = _this$options.keyframes;
    var KeyframeResolver$1 = (element === null || element === void 0 ? void 0 : element.KeyframeResolver) || KeyframeResolver;
    var onResolved = function onResolved(resolvedKeyframes, finalKeyframe) {
      return _this.onKeyframesResolved(resolvedKeyframes, finalKeyframe);
    };
    _this.resolver = new KeyframeResolver$1(keyframes, onResolved, name, motionValue, element);
    _this.resolver.scheduleResolve();
    return _this;
  }
  _inherits(MainThreadAnimation, _BaseAnimation);
  return _createClass(MainThreadAnimation, [{
    key: "initPlayback",
    value: function initPlayback(keyframes$1) {
      var _this$options2 = this.options,
        _this$options2$type = _this$options2.type,
        type = _this$options2$type === void 0 ? "keyframes" : _this$options2$type,
        _this$options2$repeat = _this$options2.repeat,
        repeat = _this$options2$repeat === void 0 ? 0 : _this$options2$repeat,
        _this$options2$repeat2 = _this$options2.repeatDelay,
        repeatDelay = _this$options2$repeat2 === void 0 ? 0 : _this$options2$repeat2,
        repeatType = _this$options2.repeatType,
        _this$options2$veloci = _this$options2.velocity,
        velocity = _this$options2$veloci === void 0 ? 0 : _this$options2$veloci;
      var generatorFactory = generators[type] || keyframes;
      /**
       * If our generator doesn't support mixing numbers, we need to replace keyframes with
       * [0, 100] and then make a function that maps that to the actual keyframes.
       *
       * 100 is chosen instead of 1 as it works nicer with spring animations.
       */
      var mapPercentToKeyframes;
      var mirroredGenerator;
      if (generatorFactory !== keyframes && typeof keyframes$1[0] !== "number") {
        if (process.env.NODE_ENV !== "production") {
          invariant(keyframes$1.length === 2, "Only two keyframes currently supported with spring and inertia animations. Trying to animate ".concat(keyframes$1));
        }
        mapPercentToKeyframes = pipe(percentToProgress, mix(keyframes$1[0], keyframes$1[1]));
        keyframes$1 = [0, 100];
      }
      var generator = generatorFactory(_objectSpread(_objectSpread({}, this.options), {}, {
        keyframes: keyframes$1
      }));
      /**
       * If we have a mirror repeat type we need to create a second generator that outputs the
       * mirrored (not reversed) animation and later ping pong between the two generators.
       */
      if (repeatType === "mirror") {
        mirroredGenerator = generatorFactory(_objectSpread(_objectSpread({}, this.options), {}, {
          keyframes: _toConsumableArray(keyframes$1).reverse(),
          velocity: -velocity
        }));
      }
      /**
       * If duration is undefined and we have repeat options,
       * we need to calculate a duration from the generator.
       *
       * We set it to the generator itself to cache the duration.
       * Any timeline resolver will need to have already precalculated
       * the duration by this step.
       */
      if (generator.calculatedDuration === null) {
        generator.calculatedDuration = calcGeneratorDuration(generator);
      }
      var calculatedDuration = generator.calculatedDuration;
      var resolvedDuration = calculatedDuration + repeatDelay;
      var totalDuration = resolvedDuration * (repeat + 1) - repeatDelay;
      return {
        generator: generator,
        mirroredGenerator: mirroredGenerator,
        mapPercentToKeyframes: mapPercentToKeyframes,
        calculatedDuration: calculatedDuration,
        resolvedDuration: resolvedDuration,
        totalDuration: totalDuration
      };
    }
  }, {
    key: "onPostResolved",
    value: function onPostResolved() {
      var _this$options$autopla = this.options.autoplay,
        autoplay = _this$options$autopla === void 0 ? true : _this$options$autopla;
      this.play();
      if (this.pendingPlayState === "paused" || !autoplay) {
        this.pause();
      } else {
        this.state = this.pendingPlayState;
      }
    }
  }, {
    key: "tick",
    value: function tick(timestamp) {
      var sample = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var resolved = this.resolved;
      // If the animations has failed to resolve, return the final keyframe.
      if (!resolved) {
        var _keyframes = this.options.keyframes;
        return {
          done: true,
          value: _keyframes[_keyframes.length - 1]
        };
      }
      var finalKeyframe = resolved.finalKeyframe,
        generator = resolved.generator,
        mirroredGenerator = resolved.mirroredGenerator,
        mapPercentToKeyframes = resolved.mapPercentToKeyframes,
        keyframes = resolved.keyframes,
        calculatedDuration = resolved.calculatedDuration,
        totalDuration = resolved.totalDuration,
        resolvedDuration = resolved.resolvedDuration;
      if (this.startTime === null) return generator.next(0);
      var _this$options3 = this.options,
        delay = _this$options3.delay,
        repeat = _this$options3.repeat,
        repeatType = _this$options3.repeatType,
        repeatDelay = _this$options3.repeatDelay,
        onUpdate = _this$options3.onUpdate;
      /**
       * requestAnimationFrame timestamps can come through as lower than
       * the startTime as set by performance.now(). Here we prevent this,
       * though in the future it could be possible to make setting startTime
       * a pending operation that gets resolved here.
       */
      if (this.speed > 0) {
        this.startTime = Math.min(this.startTime, timestamp);
      } else if (this.speed < 0) {
        this.startTime = Math.min(timestamp - totalDuration / this.speed, this.startTime);
      }
      // Update currentTime
      if (sample) {
        this.currentTime = timestamp;
      } else if (this.holdTime !== null) {
        this.currentTime = this.holdTime;
      } else {
        // Rounding the time because floating point arithmetic is not always accurate, e.g. 3000.367 - 1000.367 =
        // 2000.0000000000002. This is a problem when we are comparing the currentTime with the duration, for
        // example.
        this.currentTime = Math.round(timestamp - this.startTime) * this.speed;
      }
      // Rebase on delay
      var timeWithoutDelay = this.currentTime - delay * (this.speed >= 0 ? 1 : -1);
      var isInDelayPhase = this.speed >= 0 ? timeWithoutDelay < 0 : timeWithoutDelay > totalDuration;
      this.currentTime = Math.max(timeWithoutDelay, 0);
      // If this animation has finished, set the current time  to the total duration.
      if (this.state === "finished" && this.holdTime === null) {
        this.currentTime = totalDuration;
      }
      var elapsed = this.currentTime;
      var frameGenerator = generator;
      if (repeat) {
        /**
         * Get the current progress (0-1) of the animation. If t is >
         * than duration we'll get values like 2.5 (midway through the
         * third iteration)
         */
        var progress = Math.min(this.currentTime, totalDuration) / resolvedDuration;
        /**
         * Get the current iteration (0 indexed). For instance the floor of
         * 2.5 is 2.
         */
        var currentIteration = Math.floor(progress);
        /**
         * Get the current progress of the iteration by taking the remainder
         * so 2.5 is 0.5 through iteration 2
         */
        var iterationProgress = progress % 1.0;
        /**
         * If iteration progress is 1 we count that as the end
         * of the previous iteration.
         */
        if (!iterationProgress && progress >= 1) {
          iterationProgress = 1;
        }
        iterationProgress === 1 && currentIteration--;
        currentIteration = Math.min(currentIteration, repeat + 1);
        /**
         * Reverse progress if we're not running in "normal" direction
         */
        var isOddIteration = Boolean(currentIteration % 2);
        if (isOddIteration) {
          if (repeatType === "reverse") {
            iterationProgress = 1 - iterationProgress;
            if (repeatDelay) {
              iterationProgress -= repeatDelay / resolvedDuration;
            }
          } else if (repeatType === "mirror") {
            frameGenerator = mirroredGenerator;
          }
        }
        elapsed = clamp(0, 1, iterationProgress) * resolvedDuration;
      }
      /**
       * If we're in negative time, set state as the initial keyframe.
       * This prevents delay: x, duration: 0 animations from finishing
       * instantly.
       */
      var state = isInDelayPhase ? {
        done: false,
        value: keyframes[0]
      } : frameGenerator.next(elapsed);
      if (mapPercentToKeyframes) {
        state.value = mapPercentToKeyframes(state.value);
      }
      var done = state.done;
      if (!isInDelayPhase && calculatedDuration !== null) {
        done = this.speed >= 0 ? this.currentTime >= totalDuration : this.currentTime <= 0;
      }
      var isAnimationFinished = this.holdTime === null && (this.state === "finished" || this.state === "running" && done);
      if (isAnimationFinished && finalKeyframe !== undefined) {
        state.value = getFinalKeyframe(keyframes, this.options, finalKeyframe);
      }
      if (onUpdate) {
        onUpdate(state.value);
      }
      if (isAnimationFinished) {
        this.finish();
      }
      return state;
    }
  }, {
    key: "duration",
    get: function get() {
      var resolved = this.resolved;
      return resolved ? millisecondsToSeconds(resolved.calculatedDuration) : 0;
    }
  }, {
    key: "time",
    get: function get() {
      return millisecondsToSeconds(this.currentTime);
    },
    set: function set(newTime) {
      newTime = secondsToMilliseconds(newTime);
      this.currentTime = newTime;
      if (this.holdTime !== null || this.speed === 0) {
        this.holdTime = newTime;
      } else if (this.driver) {
        this.startTime = this.driver.now() - newTime / this.speed;
      }
    }
  }, {
    key: "speed",
    get: function get() {
      return this.playbackSpeed;
    },
    set: function set(newSpeed) {
      var hasChanged = this.playbackSpeed !== newSpeed;
      this.playbackSpeed = newSpeed;
      if (hasChanged) {
        this.time = millisecondsToSeconds(this.currentTime);
      }
    }
  }, {
    key: "play",
    value: function play() {
      var _this2 = this;
      if (!this.resolver.isScheduled) {
        this.resolver.resume();
      }
      if (!this._resolved) {
        this.pendingPlayState = "running";
        return;
      }
      if (this.isStopped) return;
      var _this$options4 = this.options,
        _this$options4$driver = _this$options4.driver,
        driver = _this$options4$driver === void 0 ? frameloopDriver : _this$options4$driver,
        onPlay = _this$options4.onPlay,
        startTime = _this$options4.startTime;
      if (!this.driver) {
        this.driver = driver(function (timestamp) {
          return _this2.tick(timestamp);
        });
      }
      onPlay && onPlay();
      var now = this.driver.now();
      if (this.holdTime !== null) {
        this.startTime = now - this.holdTime;
      } else if (!this.startTime) {
        this.startTime = startTime !== null && startTime !== void 0 ? startTime : this.calcStartTime();
      } else if (this.state === "finished") {
        this.startTime = now;
      }
      if (this.state === "finished") {
        this.updateFinishedPromise();
      }
      this.cancelTime = this.startTime;
      this.holdTime = null;
      /**
       * Set playState to running only after we've used it in
       * the previous logic.
       */
      this.state = "running";
      this.driver.start();
    }
  }, {
    key: "pause",
    value: function pause() {
      var _a;
      if (!this._resolved) {
        this.pendingPlayState = "paused";
        return;
      }
      this.state = "paused";
      this.holdTime = (_a = this.currentTime) !== null && _a !== void 0 ? _a : 0;
    }
  }, {
    key: "complete",
    value: function complete() {
      if (this.state !== "running") {
        this.play();
      }
      this.pendingPlayState = this.state = "finished";
      this.holdTime = null;
    }
  }, {
    key: "finish",
    value: function finish() {
      this.teardown();
      this.state = "finished";
      var onComplete = this.options.onComplete;
      onComplete && onComplete();
    }
  }, {
    key: "cancel",
    value: function cancel() {
      if (this.cancelTime !== null) {
        this.tick(this.cancelTime);
      }
      this.teardown();
      this.updateFinishedPromise();
    }
  }, {
    key: "teardown",
    value: function teardown() {
      this.state = "idle";
      this.stopDriver();
      this.resolveFinishedPromise();
      this.updateFinishedPromise();
      this.startTime = this.cancelTime = null;
      this.resolver.cancel();
    }
  }, {
    key: "stopDriver",
    value: function stopDriver() {
      if (!this.driver) return;
      this.driver.stop();
      this.driver = undefined;
    }
  }, {
    key: "sample",
    value: function sample(time) {
      this.startTime = 0;
      return this.tick(time, true);
    }
  }]);
}(BaseAnimation); // Legacy interface
function animateValue(options) {
  return new MainThreadAnimation(options);
}
export { MainThreadAnimation, animateValue };